async function update_concluir_cadastro(dados, aprovador) {
 const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      data: dados,
      aprovador: aprovador,
      access_token: sessionStorage.getItem("token"),
    }),
  };

  try {
    const response = await fetch(
      process.env.REACT_APP_LABS_API + "OEC/empresa/update_concluir_cadastro.php",
      requestOptions
    );
    const json = await response.json();
        return json;
  } catch (error) {
    console.error("Erro ao atualizar o cadastro: ", error);
    return { success: false, error: error.message };
  }
}

async function reverterAtualizacaoOEC(userId, cnpj, contaProvisoria, aprovador) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      rollback: true,
      userId: userId,
      cnpj: cnpj,
      contaProvisoria: contaProvisoria,
      aprovador: aprovador,
      access_token: sessionStorage.getItem("token"),
    }),
  };

  try {
    const response = await fetch(
      process.env.REACT_APP_LABS_API + "OEC/empresa/update_concluir_cadastro.php",
      requestOptions
    );
    const json = await response.json();
    return json;
  } catch (error) {
    console.error("Erro ao reverter atualização do OEC: ", error);
    return { success: false, error: error.message };
  }
}

export { update_concluir_cadastro, reverterAtualizacaoOEC };
